export default __webpack_public_path__ + "static/media/3d.1e6c9017.png";